<!--<page-header title="Registration Successful"></page-header>-->
<!--<div class="header-text">-->
<!--  Thank you for verifying your account and completing your registration. Please contact your administrator for next steps.-->
<!--</div>-->
<div *ngIf="success">
  <div class="registration-complete">
    <h4>Registration Complete!</h4>
    <p>Congratulations, you have successfully setup your business account.</p>

    <button mat-raised-button type="button" routerLink="/admin/users" (click)="dialogRef?.close()">Admin Panel</button>
    <button mat-raised-button type="button" routerLink="/" (click)="dialogRef?.close()">Go to Home Page</button>
  </div>
</div>

<panels>
  <panel label="Personal Information">
    <form class="panel-1" [formGroup]="form">
      <mat-form-field floatLabel="always">
        <mat-label>Full Name</mat-label>
        <input matInput type="text" formControlName="fullName" readonly />
        <mat-error>{{ form.get('fullName')?.errors | formError }}</mat-error>
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" readonly />
        <mat-error>{{ form.get('email')?.errors | formError }}</mat-error>
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>Phone Number</mat-label>
        <input matInput type="text" formControlName="phone" mask="(000) 000 - 0000" />
        <mat-error>{{ form.get('phone')?.errors | formError }}</mat-error>
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>Job Position</mat-label>
        <input matInput type="text" formControlName="jobPosition" />
        <mat-error>{{ form.get('jobPosition')?.errors | formError }}</mat-error>
      </mat-form-field>
    </form>
  </panel>
</panels>
